import { useCallback, useMemo } from "react";
import { useAuthenticated } from "./useAuthenticated";

export function useUserOffices() {
  const {
    userContext: { authenticatedUser }
  } = useAuthenticated();

  const offices = useMemo(
    () => authenticatedUser?.offices?.offices ?? [],
    [authenticatedUser?.offices?.offices]
  );

  const officeIds = useMemo(
    () => new Set(offices.map((o) => o.id)),
    [offices]
  );

  const hasOffice = useCallback(
    (officeId: string) => officeIds.has(officeId),
    [officeIds]
  );

  return { offices, officeIds, hasOffice };
}
